import gql from "graphql-tag";

export const MY_TIMESHEET_GET_EXAMINERS = gql`
  query getMyTimesheetExaminersName($contractCode: String!, $locale: String!) {
    getMyTimesheetExaminersName(contractCode: $contractCode, locale: $locale)
  }
`;
